// extracted by mini-css-extract-plugin
export default {"risk-assessment":"fIK1E5A2r7wiWvRcU7Mv","policy-id-link":"nOAUiOEE2lalxdNTmull"};